import { defineStore } from 'pinia';
import { getToken } from '@/service/authLogin';
import axios from 'axios';

export const mainSettings = defineStore('mainSettings', {
  state: () => ({
    token: getToken(),
    route: process.env.VUE_APP_API,
  }),
  actions: {
    async getDefaultSettings() {
      try {
        const response = await axios.get(`${this.route}/api/showSetup`, {
          headers: this.token,
        });
        return response.data.original.data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async updateNewSettings(newSettings) {
      try {
        const response = await axios.post(`${this.route}/api/saveSetup`, newSettings, {
          headers: this.token,
        });
        return response.data.original;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
  },
});
